{
  "title": "Tenants",
  "subtitle": "Every customer organisation on the platform",
  "subtitlePartnerView": "Customers attributed to this partner",
  "addTenant": "Add tenant",
  "onlyMspCanAdd": "Only MSP administrators can add tenants",
  "cannotAddTenant": "You need MSP or partner administrator access to add a tenant",
  "loadError": "Could not load tenants",
  "emptyTitle": "No tenants yet",
  "emptyDescription": "A tenant is one customer organisation. Adding one starts the onboarding wizard, which walks through consent, connectors, a pilot group, and validation before any of their mail is touched.",
  "emptyTitlePartnerView": "No customers for this partner yet",
  "emptyDescriptionPartnerView": "Add a customer to open onboarding for them. New tenants created here are attributed to this partner automatically.",
  "colTenant": "Tenant",
  "colOnboarding": "Onboarding",
  "colStamping": "Stamping",
  "colDomains": "Domains",
  "colSnapshot": "Snapshot",
  "noneSynced": "none synced",
  "orgName": "Organisation name",
  "orgNamePlaceholder": "Contoso Pty Ltd",
  "slug": "Slug",
  "slugDescription": "Lower-case, used in URLs and in the tenant's certificate subject. Cannot be changed after onboarding starts.",
  "slugError": "Lower-case letters, digits and hyphens only.",
  "createError": "Could not create tenant",
  "onboardingStateCreated": "Created",
  "onboardingStateConsented": "Consented",
  "onboardingStateConnectors": "Connectors created",
  "onboardingStatePilot": "Pilot",
  "onboardingStateValidated": "Validated",
  "onboardingStateOrgWide": "Org-wide",
  "onboardingStateOffboarding": "Offboarding",
  "stampingActive": "Active",
  "stampingActivePilot": "Active (pilot)",
  "stampingBypassed": "Bypassed",
  "stampingBypassedAuto": "Bypassed (automatic)",
  "noReasonRecorded": "No reason recorded",
  "overview": "Overview",
  "defaultFieldsTitle": "Default fields",
  "defaultFieldsHint": "These values fill blank directory fields for everyone. Group fills still win for members; a personal override always wins.",
  "defaultFieldsSaved": "Default fields saved.",
  "tabSettings": "Settings",
  "tabBilling": "Billing",
  "tabAccess": "Access",
  "tabDirectory": "Directory",
  "loadTenantError": "Could not load tenant",
  "deleteTenant": "Delete tenant",
  "deleteConfirmTitle": "Delete this tenant?",
  "deleteConfirmBody": "This removes {{name}} from lists and stamping. The row is kept for audit and billing history.",
  "partner": "Partner",
  "noPartner": "No partner",
  "stampingMode": "Stamping mode",
  "bypassReason": "Reason for bypass",
  "setActive": "Set active",
  "setBypass": "Bypass stamping",
  "smartHost": "Smart host",
  "verifiedDomains": "Verified domains",
  "snapshotVersion": "Snapshot version",
  "noAccessPartners": "No access to partners",
  "noAccessPartnersBody": "Reseller arrangements are managed by OnBrand Mail staff.",
  "tabSignatures": "Signatures",
  "tabRules": "Rules",
  "tabCampaigns": "Campaigns",
  "tabUsers": "Users",
  "tenantNotFound": "Tenant not found",
  "tenantNotFoundBody": "This tenant does not exist, or you do not have access to it.",
  "openDesigner": "Open designer",
  "loadTemplatesError": "Could not load templates",
  "noTemplatesTitle": "No templates yet",
  "noTemplatesDescription": "Design, publish, and organise signature templates for this tenant. Everything starts in the designer.",
  "templatesAssignableHint": "Templates this tenant's rules can assign.",
  "renderingSignaturesTitle": "Rendering signatures",
  "renderingSignaturesBody": "A publish or rule change is being applied to this tenant's mailboxes. Until it finishes, senders keep the signature they already had.",
  "lastRenderFailed": "The last render failed",
  "retriedTimes": "Retried {{count}} times.",
  "publishedDate": "published {{date}}",
  "neverPublished": "never published",
  "templateStatusDraft": "Draft",
  "templateStatusPublished": "Published",
  "templateStatusArchived": "Archived",
  "openRulesEditor": "Open rules editor",
  "loadRulesError": "Could not load rules",
  "noRulesTitle": "No rules yet",
  "noRulesDescription": "Without a default or a rule, nothing is stamped. Set a default signature on the Users tab, or open the rules editor to add a narrower rule.",
  "rulesEvalHint": "Evaluated top to bottom; the first match wins.",
  "matchesNobody": "Matches nobody",
  "matchesNobodyTooltip": "An empty sender scope matches nobody, so this rule never fires.",
  "newWithTemplate": "New: {{name}}",
  "newNoTemplate": "New: no template",
  "replyWithTemplate": "Reply: {{name}}",
  "replySameAsNew": "Reply: same as new",
  "primaryDefault": "Primary default",
  "defaultBadge": "Default",
  "everyone": "Everyone",
  "stampingStoppedAutoTitle": "Stamping stopped on its own",
  "stampingBypassedTitle": "Stamping is bypassed",
  "stampingStoppedAutoBody": "A mail-flow node stopped stamping this tenant after repeated failures, at {{when}}. Nobody switched it off. Mail is flowing unstamped.",
  "stampingBypassedBody": "Mail for this tenant is relayed unmodified.",
  "stampingModeHint": "Bypass relays this tenant's mail untouched while keeping OnBrand Mail in the path. Use it when signatures are wrong or the render path is failing — not when mail itself cannot flow.",
  "resumeStamping": "Resume stamping",
  "stampingModePermission": "Tenant administrators and above can change stamping mode.",
  "operations": "Operations",
  "operationsHint": "Connect the customer's directory, generate Exchange connectors, and verify the mail path here. The configuration tester checks DNS, TLS and the relay before mail is routed through the platform.",
  "onboardingWizard": "Onboarding wizard",
  "configurationTester": "Configuration tester",
  "mspOperations": "MSP operations",
  "mspOperationsHint": "Snapshot bumps force mail-flow nodes to reload rules and templates. Rotating the stamping secret invalidates the previous one — update the tenant's transport rule before mail resumes.",
  "bumpSnapshot": "Bump snapshot",
  "snapshotBumped": "Snapshot bumped to v{{version}}.",
  "bumpFailed": "Bump failed.",
  "rotateStampingSecret": "Rotate stamping secret",
  "deleteTenantHint": "Removes this organisation from the platform. Stamping stops immediately and the tenant disappears from every list. Remove Exchange connectors and transport rules first if mail still flows through OnBrand Mail — deletion does not tear those down.",
  "bypassPlaceholder": "INC-4711 render failure, bypassed pending investigation",
  "resumePlaceholder": "INC-4711 resolved; resume after canary passed",
  "signatureRendering": "Signature rendering",
  "signatureRenderingHint": "Signatures are rendered per mailbox ahead of time, so stamping a message is a lookup rather than a render. Publishing a template or changing a rule queues this automatically.",
  "renderingNow": "Rendering now",
  "queued": "Queued",
  "lastCompletedAt": "Last completed {{when}}",
  "nothingRenderedYet": "Nothing rendered yet",
  "rerenderQueued": "Re-render queued. Signatures update within a few seconds.",
  "rerenderFailed": "Could not queue a re-render.",
  "rerenderSignatures": "Re-render signatures",
  "rerenderPermission": "Tenant administrators and above can force a re-render.",
  "stampingBypassedToast": "Stamping bypassed. Mail is relayed unmodified.",
  "stampingResumedToast": "Stamping resumed.",
  "reasonRequiredHint": "A reason is required. It is shown on the tenant and read during incidents.",
  "updateStampingError": "Could not update stamping mode",
  "bypassConfirm": "Bypass",
  "resumeConfirm": "Resume",
  "copySecretNowTitle": "Copy this now",
  "copySecretNowBody": "The secret is shown once. Only its hash is stored. Paste it into the tenant's transport rule before mail is attributed again.",
  "copySecretButton": "Copy secret",
  "rotateConfirmHint": "Rotating invalidates the previous secret immediately. Type {{word}} to confirm.",
  "confirmation": "Confirmation",
  "rotateSecretError": "Could not rotate secret",
  "deleteCannotUndo": "This cannot be undone from the portal",
  "deleteWarningBody": "{{name}} ({{slug}}) will leave every tenant list and stop being stamped. Exchange connectors and transport rules are not removed automatically.",
  "typeSlugToConfirm": "Type {{slug}} to confirm",
  "deleteTenantError": "Could not delete tenant",
  "tenantDeleted": "{{name}} has been deleted.",
  "noRoleBody": "You do not have a role on this tenant.",
  "readOnlyTitle": "Read-only",
  "noAccessTenantTitle": "No access to this tenant",
  "noAccessRulesTitle": "No access to these rules",
  "readOnlyRulesBody": "You can see the rules and run the tester, but changing them needs the Editor role.",
  "noAccessDesignerTitle": "No access to this designer",
  "noAccessDesignerBody": "You need the Designer role or above on this tenant to edit its signature templates.",
  "noAccessUsersTitle": "No access to these users",
  "readOnlyUsersBody": "You can see mailboxes and signatures, but overrides need the Tenant Admin role.",
  "noAccessGroupsTitle": "No access to these groups",
  "readOnlyGroupsBody": "You can see synced groups, but overrides need the Tenant Admin role.",
  "noAccessCampaignsTitle": "No access to these campaigns",
  "readOnlyCampaignsBody": "You can see campaigns, but creating or changing them needs the Editor role."
}
